// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"e1d5242b","513":"8164f563","703":"194738d9","787":"66a375c8"}[chunkId] + ".chunk.js";
};